export default "__VITE_ASSET__9f10805b__"